
import { Component, Watch, Prop, VModel } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import DialogTemplate from '@/_components/dialog/template/template.vue'

import ProjectFilter from './projects.vue'
import VisibilityFilter from '../filters/visibility.vue'
import StatusFilter from '../status.vue'
import PriorityFilter from '../priority.vue'
import SeverityFilter from '../severity.vue'
import DueStatusFilter from '../filters/dueStatus.vue'
import ArchivedFilter from './archived.vue'
import WatchingFilter from './watching.vue'
import TreeitemFilter from '../filters/treeitem.vue'
import TreeitemGroupFilter from '../filters/treeitemGroup.vue'
import ReporterIsNullFilter from './reporterIsNull.vue'
import ContractorFilter from '@/views/Project/Observation/components/contractorPicker.vue'

import RelatedCompaniesFilter from './relatedCompanies.vue'
import PeriodFilter from './period.vue'
import CostFilter from './cost.vue'
import UsersFilter from '@/views/Project/Observation/components/userAutocomplete.vue'
import {
    observationArrayValues,
    observationObjectValues,
    observationSingleValues,
    sortFilters,
} from '@/types/observation'
@Component({
    mixins: [ObservationMixin],
    components: {
        DialogTemplate,
        ProjectFilter,
        VisibilityFilter,
        StatusFilter,
        PriorityFilter,
        SeverityFilter,
        DueStatusFilter,
        ArchivedFilter,
        WatchingFilter,
        TreeitemFilter,
        TreeitemGroupFilter,
        ReporterIsNullFilter,
        ContractorFilter,
        RelatedCompaniesFilter,
        PeriodFilter,
        CostFilter,
        UsersFilter,
    },
})
export default class FiltersComponent extends Mixins<MixinInterface>(ObservationMixin) {
    @VModel() filters!: Record<string, any>
    @Prop({ required: true }) meMode!: boolean
    localFilters = {} as Record<string, any>

    dialog = false

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    // Store values

    get projects() {
        return this.$store.getters.projects
    }

    get categories() {
        return this.$store.getters.observationCategories
    }

    get causes() {
        return this.$store.getters.observationCauses
    }

    get locations() {
        return this.$store.getters.projectLocations
    }

    // Filters
    filterLabel(key: any) {
        switch (key) {
            case 'categoryName':
                key = 'category'
                break
            case 'causeName':
                key = 'cause'
                break
            case 'locationName':
                key = 'location'
                break
        }

        const translationKey = `observation_labels['observation.${key}']`
        return this.$te(translationKey)
            ? this.$t(translationKey)
            : this.$t(`observation_fe['filter.${key}.label']`)
    }

    allFilters = [...observationSingleValues, ...observationArrayValues, ...observationObjectValues]

    get availableFilters() {
        let arr = this.allFilters

        if (this.project) {
            arr = arr.filter(
                (filter) =>
                    filter != 'project' &&
                    filter != 'relatedCompanies' &&
                    filter != 'categoryName' &&
                    filter != 'causeName' &&
                    filter != 'locationName'
            )
        } else if (this.group) {
            arr = arr.filter(
                (filter) =>
                    filter != 'contractors' &&
                    filter != 'category' &&
                    filter != 'cause' &&
                    filter != 'location'
            )
        }

        if (this.meMode) {
            arr = arr.filter(
                (filter) =>
                    filter != 'status' &&
                    filter != 'responsibleUser' &&
                    filter != 'responsibleLeader'
            )
        }

        return sortFilters(this.lodash.difference(arr, this.addedFilters)).map((item) => {
            return {
                value: item,
                text: this.filterLabel(item),
            }
        })
    }

    addedFilters = [] as Array<string>

    addFilter() {
        if (this.availableFilters[0]) {
            this.initFilterValue(this.availableFilters[0].value)
            this.addedFilters.push(this.availableFilters[0].value)
        }
    }

    deleteFilter(index: number) {
        this.initFilterValue(this.addedFilters[index])
        this.addedFilters.splice(index, 1)
    }

    initFilterValue(filter: string) {
        if (observationSingleValues.includes(filter)) {
            this.localFilters[filter] = null
        } else if (observationArrayValues.includes(filter)) {
            this.localFilters[filter] = []
        } else if (observationObjectValues.includes(filter)) {
            this.localFilters[filter] = {
                ge: null,
                le: null,
                period: null,
            }
        }
    }

    selectFilters(removeAll = false) {
        Object.keys(this.localFilters).map((key) => {
            if (removeAll || !this.addedFilters.includes(key)) {
                if (observationSingleValues.includes(key)) {
                    this.localFilters[key] = null
                } else if (observationArrayValues.includes(key)) {
                    this.localFilters[key] = []
                } else if (observationObjectValues.includes(key)) {
                    this.localFilters[key] = {
                        le: null,
                        ge: null,
                        period: null,
                    }
                }
            }
        })

        this.filters = this.lodash.cloneDeep(this.localFilters)

        this.dialog = false
    }

    filterCount = 0
    singleFilter = null as null | string

    handleFilters(setAdded = false, setCount = false) {
        if (setAdded) this.addedFilters = []
        if (setCount) {
            this.filterCount = 0
            this.singleFilter = null
        }

        Object.keys(this.filters).map((filter) => {
            if (observationSingleValues.includes(filter)) {
                if (this.filters[filter] != null) {
                    if (setAdded) this.addedFilters.push(filter)
                    if (setCount) {
                        this.filterCount = this.filterCount + 1
                        this.singleFilter = filter
                    }
                }
            } else if (observationArrayValues.includes(filter)) {
                if (this.filters[filter] && this.filters[filter].length != 0) {
                    if (setAdded) this.addedFilters.push(filter)
                    if (setCount) {
                        this.filterCount = this.filterCount + 1
                        this.singleFilter = filter
                    }
                }
            } else if (observationObjectValues.includes(filter)) {
                if (
                    this.filters[filter]['ge'] != null ||
                    this.filters[filter]['le'] != null ||
                    this.filters[filter]['period'] != null
                ) {
                    if (setAdded) this.addedFilters.push(filter)
                    if (setCount) {
                        this.filterCount = this.filterCount + 1
                        this.singleFilter = filter
                    }
                }
            }
        })
        this.$emit('setFilterCount', this.filterCount)
    }

    @Watch('dialog', { immediate: true })
    @Watch('filters', { deep: true })
    async setFilters() {
        if (this.dialog) {
            this.localFilters = this.lodash.cloneDeep(this.filters)
            this.handleFilters(true)
            if (this.filterCount == 0) this.addFilter()
        } else {
            this.handleFilters(false, true)
        }
    }
}
